<template>
  <v-row justify="center">

    <v-col cols="12">
      <h3 class="text-h6">¿Cuando quisieras recibir tu pedido?</h3>
    </v-col>

    <v-col cols="12">
      <customer-time-mode ></customer-time-mode>
    </v-col>

    <v-col cols="12" v-if="isAsSoonAsPosible">
      <schedule-as-soon-as-posible v-model="deliveryTime"></schedule-as-soon-as-posible>
    </v-col>

    <v-col cols="12" v-if="isScheduled">
      <schedule-time-combobox v-model="deliveryTime"></schedule-time-combobox>
    </v-col>


  </v-row>
</template>

<script>
import CustomerTimeMode from "@/modules/delivery/components-core/customer/CustomerTimeMode/CustomerTimeMode.vue";
import ScheduleTimeCombobox
  from "@/modules/delivery/components-core/shared/ScheduleTimeCombobox/ScheduleTimeCombobox.vue";
import ScheduleAsSoonAsPosible
  from "@/modules/delivery/components-core/shared/ScheduleAsSoonAsPosible/ScheduleAsSoonAsPosible.vue";

export default {
  name: "CustomerOrderModeTakeAway",
  components: {ScheduleAsSoonAsPosible, ScheduleTimeCombobox, CustomerTimeMode},
  computed: {
    isCalendarActive() {
      return this.$store.state.orderStore.orderSystem.isCalendarTakeAwayActive()
    },
    isScheduled() {
      return this.$store.getters.orderSystem.order.isScheduled
    },
    isAsSoonAsPosible() {
      return this.$store.getters.orderSystem.order.isAsSoonAsPossible
    },
    deliveryTime: {
      get() {
        return this.$store.getters.deliveryTime;
      },
      set(value) {
        this.$store.commit("orderTime", value);
      }
    }
  }
}
</script>

<style scoped>

</style>
